module.exports = __webpack_public_path__ + "img/tshirt_poli.7c671b5d.png";